<template>
  <section
    id="socials"
    class="z-10 relative overflow-x-hidden pt-10 md:pt-[120px] pb-[87px]"
  >
    <h1
      class="text-2xl md:text-[32px] md:leading-10 font-bold font-orbitron text-white text-center text-shadow"
    >
      Follow Our Socials
    </h1>

    <div
      v-motion-pop-visible
      class="flex flex-row justify-center items-center gap-3 mt-[5px] sm:mt-[31px]"
    >
      <!-- Instagram Button -->
      <!-- <a v-motion-pop-visible href="" target="_blank" class="hover:cursor-pointer">
        <img
          src="../assets/instagram.png"
          class="object-contain w-12 h-12 sm:w-12 sm:h-12 md:w-14 md:h-14 lg:w-20 lg:h-20"
          alt="instagram"
        />
      </a> -->
      <!-- Discord Button -->
      <a
        href="https://discord.gg/aDFEysUmfP"
        target="_blank"
        class="hover:cursor-pointer"
      >
        <img
          src="../assets/discord.png"
          class="object-contain  h-[73px] sm:h-16 w-auto"
          alt="discord"
        />
      </a>
      <!-- X Button -->
      <!-- <a
        href="https://x.com/cryptolunae"
        target="_blank"
        class="hover:cursor-pointer"
      >
        <img
          src="../assets/X.png"
          class="object-contain  h-[73px] sm:h-16 w-auto"
          alt="X"
        />
      </a> -->
      <!-- YouTube Button -->
      <a
        href="https://www.youtube.com/@realcryptomoonlight2019/videos"
        target="_blank"
        class="hover:cursor-pointer"
      >
        <img
          src="../assets/youtube.png"
          class="object-contain  h-[73px] sm:h-16 w-auto"
          alt="youtube"
        />
      </a>
      <!-- Kick Button -->
      <a
        href="https://kick.com/moonlight2019"
        target="_blank"
        class="hover:cursor-pointer"
      >
        <img
          src="../assets/kick.png"
          class="object-contain  h-[73px] sm:h-16 w-auto"
          alt="kick"
        />
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: "SocialSection",
};
</script>
